<!-- 友情链接 -->
<template>
  <div
    class="link_bg"
    :style="
      $route.query.title == '器检党建' || $route.path == '/special-column'
        ? 'background:none'
        : ''
    "
  >
    <div class="version-center friendship-link">
      <div
        class="flex"
        :class="{ 'fffcolor': $route.path == '/special-column' }"
      >
        <b>友情链接 : </b>
        <div>
          <span
            v-for="(item, i) in linKArr.filter((item) => item.viewPermission)"
            :key="i"
          >
            <a
              target="_blank"
              :href="item.link"
              v-if="item.viewPermission && !item.displayImages"
              >{{ item.linkName }}
            </a>
          </span>
        </div>
      </div>
      <vue-seamless-scroll
        :data="
          linKArr.filter((item) => item.displayImages && item.viewPermission)
        "
        :class-option="classOption"
        class="version-center"
      >
        <div class="ul-item">
          <a
            class="li-item"
            v-for="(item, i) in linKArr.filter(
              (item) => item.displayImages && item.viewPermission
            )"
            :key="i"
            :href="item.link"
            target="_blank"
            v-if="item.displayImages && item.viewPermission"
          >
            <img :src="path + item.photoPath" :alt="item.linkName" />
          </a>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
import { getBlogrollList } from '@/api/index'
export default {
  linkTitle: '',
  props: [],
  data() {
    return {
      linKArr: [],
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        // step: 7,
        // limitMoveNum: 1,
        // direction: 2,
        // singleWidth: 242,
        // waitTime: 2000
        step: 1,
        limitMoveNum: 1,
        direction: 2
      }
    }
  },
  watch: {},
  methods: {
    // 跳转第三方链接
    onMenuLinkItem(url) {
      window.open(url, '_blank')
    }
  },
  mounted() {
    getBlogrollList({ page: 0, size: 10 })
      .then((res) => {
        this.linKArr = res.content
      })
      .finally(() => {})
  },
  created() {}
}
</script>

<style lang="scss" scope>
.link_bg {
  width: 100%;
  height: 157px;
  background: url(../assets/images/link_bg.webp) no-repeat;
  background-size: cover;
  padding: 32px 0 0;
}
.friendship-link {
  margin: 0 auto 0px !important;
  b {
    display: inline-block;
    min-width: 60px;
  }
  a {
    display: inline-block;
    margin-left: 16px;
    font-weight: 400;
    font-size: 18px;
    color: #000;
    margin-bottom: 14px;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      color: #000;
      font-weight: 800;
      transform: scale(1.01);
    }
  }
  .fffcolor {
    b,
    a {
      color: #fff;
    }
  }
  .version-center {
    width: 1200px;
    height: 58px;
    margin: 0 auto;
    overflow: hidden;
    .ul-item {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      display: flex;
      .li-item {
        margin: 0;
        display: block;
        width: 240px;
        width: 240px;
        margin-right: 15px;
        img {
          width: 100%;
          height: 58px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .friendship-link {
    a {
      font-size: 16px;
    }
  }
}
</style>
